//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Lee_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Lee_info.vue